var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimesheet2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5.5C19.5899 5.5 22.5 8.41015 22.5 12C22.5 15.5899 19.5899 18.5 16 18.5C12.4101 18.5 9.5 15.5899 9.5 12C9.5 8.41015 12.4101 5.5 16 5.5Z",
    stroke: "#636980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.50002V4.5C17 3.96957 16.7893 3.46086 16.4142 3.08579C16.0391 2.71071 15.5304 2.5 15 2.5H4C3.46957 2.5 2.96086 2.71071 2.58579 3.08579C2.21071 3.46086 2 3.96957 2 4.5V19.5C2 20.0304 2.21071 20.5391 2.58579 20.9142C2.96086 21.2893 3.46957 21.5 4 21.5H15C15.5304 21.5 16.0391 21.2893 16.4142 20.9142C16.7893 20.5391 17 20.0304 17 19.5V18.5",
    stroke: "#636980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9V12L18 13.5",
    stroke: "#636980",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesheet2);
export default __webpack_public_path__ + "static/media/Timesheet 2.e6281f248e19f7d4b37c20022c40d8a8.svg";
export { ForwardRef as ReactComponent };